// Чистая логика вочдога KkmServer: классификация ошибок пробы, лимит автозапусков,
// порог зависания, тексты диалога. Без зависимостей и алиасов - тестируется голым
// `node --test 'tests/kkm/*.test.mjs'`. CommonJS, как pipeline-core.js.
// Спека: docs/superpowers/specs/2026-10-23-kkm-watchdog-design.md (репо fakt-crm-cloude).

const PROBE_INTERVAL_MS = 30000
const PROBE_TIMEOUT_MS = 5000
const START_WAIT_MS = 20000
const START_POLL_MS = 2000
const MAX_AUTO_STARTS = 3
const AUTO_START_WINDOW_MS = 10 * 60000
const HUNG_AFTER_TIMEOUTS = 2
const DIALOG_SNOOZE_MS = 5 * 60000

const STATUS = {
  Unknown: 'unknown',
  Ok: 'ok',
  Starting: 'starting',
  Down: 'down',
  Hung: 'hung',
}

// Ответ сервера с любым кодом = жив; таймаут axios (ECONNABORTED) или нашей обёртки
// sendCommand («KkmServer timeout») = завис; остальное = нет связи, процесса нет
function classifyProbeError (error) {
  if (!error) return 'down'
  if (error.response) return 'alive'
  if (error.code === 'ECONNABORTED' || error.code === 'ETIMEDOUT') return 'timeout'
  if (/timeout/i.test(error.message || '')) return 'timeout'
  return 'down'
}

function pruneStarts (startTimes, nowMs) {
  return startTimes.filter(t => nowMs - t < AUTO_START_WINDOW_MS)
}

function canAutoStart (startTimes, nowMs) {
  return pruneStarts(startTimes, nowMs).length < MAX_AUTO_STARTS
}

function nextStatusAfterTimeout (timeoutsInRow) {
  return timeoutsInRow >= HUNG_AFTER_TIMEOUTS ? STATUS.Hung : STATUS.Unknown
}

// Версия из пробы (GET /VersionJSON). Пустой ответ (старый KkmServer без маршрута) - версия неизвестна
function serverInfoFromVersion (version, nowMs) {
  return {
    version: version || null,
    lastSeenAt: nowMs,
  }
}

function dialogTexts (status) {
  if (status === STATUS.Hung) {
    return {
      title: 'KkmServer не отвечает',
      content: 'KkmServer запущен, но не отвечает на команды. Перезапустите его кнопкой ниже ' +
        'или вручную и нажмите «Проверить». Если KkmServer работает, проверьте адрес в настройках.',
    }
  }
  return {
    title: 'KkmServer не запущен',
    content: 'Не удалось запустить KkmServer автоматически. Запустите его вручную и нажмите ' +
      '«Проверить». Если KkmServer запущен, проверьте адрес в настройках.',
  }
}

module.exports = {
  PROBE_INTERVAL_MS,
  PROBE_TIMEOUT_MS,
  START_WAIT_MS,
  START_POLL_MS,
  MAX_AUTO_STARTS,
  AUTO_START_WINDOW_MS,
  HUNG_AFTER_TIMEOUTS,
  DIALOG_SNOOZE_MS,
  STATUS,
  classifyProbeError,
  pruneStarts,
  canAutoStart,
  nextStatusAfterTimeout,
  serverInfoFromVersion,
  dialogTexts,
}
